import Trackables from 'automation-ui-usage-tracking/Trackables';
import PropTypes from 'prop-types';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
// @ts-expect-error untyped module
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DocLinkPropTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired
};
export const DocLink = ({
  children,
  href
}) => {
  const trackEvent = useTrackEvent();
  return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
    onClick: event => {
      event.stopPropagation();
      trackEvent(Trackables.VIEW_DOC, {
        document: href
      });
    },
    url: href,
    children: children
  });
};
DocLink.propTypes = DocLinkPropTypes;